import { useEffect, useRef, useState } from 'react';

export default function StorefrontHero() {
  const [loaded, setLoaded] = useState(false);
  const parallaxRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!parallaxRef.current) return;
      const x = (e.clientX / window.innerWidth - 0.5) * 14;
      const y = (e.clientY / window.innerHeight - 0.5) * 14;
      parallaxRef.current.style.transform = `translate(${x}px, ${y}px) scale(1.05)`;
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <section className="relative w-full h-screen overflow-hidden bg-black">
      {/* Background */}
      <div className="absolute inset-0 overflow-hidden">
        <div
          ref={parallaxRef}
          className="absolute inset-[-5%] transition-transform duration-700 ease-out"
        >
          <img
            src="https://static.readdy.ai/image/79bbd12133c9c5c423ad9964f66c8be6/a508fb319aca96c8f640f7f51bdceb55.png"
            alt="Bond Street Storefront"
            className="w-full h-full object-cover object-center"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/25 to-black/85" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-transparent to-black/30" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col justify-end h-full px-8 md:px-20 pb-28">
        <div
          className={`transition-all duration-1000 delay-200 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <p
            className="text-[#4D1815] text-xs mb-5"
            style={{ letterSpacing: '0.55em', fontFamily: "'Cormorant Garamond', serif" }}
          >
            — STOREFRONT &amp; WINDOW DESIGN —
          </p>
        </div>

        <div
          className={`transition-all duration-1100 delay-400 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          <h1
            className="text-[#EADDCC] font-light leading-none mb-5"
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: 'clamp(42px, 7.5vw, 108px)',
              letterSpacing: '0.09em',
            }}
          >
            BOND STREET
            <br />
            <em className="italic text-[#EADDCC]/60">LONDON</em>
          </h1>
        </div>

        <div
          className={`transition-all duration-1000 delay-600 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
        >
          <div className="w-14 h-px bg-[#4D1815] mb-6" />
          <p
            className="text-[#EADDCC]/55 text-sm md:text-base font-light max-w-lg"
            style={{ fontFamily: "'Cormorant Garamond', serif", letterSpacing: '0.05em', lineHeight: 1.9 }}
          >
            Where the beast enters the luxury space.
            <br />
            Control meets chaos. Elegance meets instinct.
          </p>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 right-12 flex flex-col items-center gap-2 opacity-35">
        <div className="w-px h-14 bg-[#EADDCC] animate-pulse" />
        <span
          className="text-[#EADDCC] text-xs rotate-90 origin-center mt-2"
          style={{ letterSpacing: '0.3em', fontSize: '9px' }}
        >
          SCROLL
        </span>
      </div>
    </section>
  );
}
